"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureComposer;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComposerModalsContainer = _interopRequireDefault(require("composer-lib/containers/modals/ComposerModalsContainer"));

var _ComposerContainer = _interopRequireDefault(require("composer-lib/containers/composer/ComposerContainer"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _constants = require("composer-lib/lib/constants");

var _classnames = _interopRequireDefault(require("classnames"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _auth = require("composer-lib/redux/actions/auth");

var _composer = require("composer-lib/redux/actions/composer");

var _configureStore = _interopRequireDefault(require("composer-lib/lib/configureStore"));

var COMPOSER_FEATURE_VALUES = Object.keys(_constants.ComposerFeatures).map(function (k) {
  return _constants.ComposerFeatures[k];
});
var INCLUDED_INLINE_STYLE_VALUES = Object.keys(_constants.RICH_TEXT_STYLES.INLINE_STYLES.INCLUDED_STYLES).map(function (k) {
  return _constants.RICH_TEXT_STYLES.INLINE_STYLES.INCLUDED_STYLES[k];
});
var HEADER_BLOCK_STYLE_VALUES = Object.keys(_constants.RICH_TEXT_STYLES.BLOCK_STYLES.HEADER_STYLES).map(function (k) {
  return _constants.RICH_TEXT_STYLES.BLOCK_STYLES.HEADER_STYLES[k];
});
var LIST_BLOCK_STYLE_VALUES = Object.keys(_constants.RICH_TEXT_STYLES.BLOCK_STYLES.LIST_STYLES).map(function (k) {
  return _constants.RICH_TEXT_STYLES.BLOCK_STYLES.LIST_STYLES[k];
});
var MISC_BLOCK_STYLE_VALUES = Object.keys(_constants.RICH_TEXT_STYLES.BLOCK_STYLES.MISC_STYLES).map(function (k) {
  return _constants.RICH_TEXT_STYLES.BLOCK_STYLES.MISC_STYLES[k];
});

function parseComposerFeaturesIntoKeyMirror(featuresArray) {
  var features = {};
  featuresArray.forEach(function (feature) {
    if (COMPOSER_FEATURE_VALUES.includes(feature)) {
      features[feature] = null;
    }
  });
  return (0, _keyMirror.default)(features);
}

function parseRichTextStyles(richTextStyles) {
  var includedStyles = [];
  var listStyles = [];
  var headerStyles = [];
  var miscStyles = [];
  richTextStyles.INLINE_STYLES.forEach(function (inlineStyle) {
    if (INCLUDED_INLINE_STYLE_VALUES.includes(inlineStyle)) {
      includedStyles.push(inlineStyle);
    }
  });
  richTextStyles.BLOCK_STYLES.forEach(function (blockStyle) {
    if (LIST_BLOCK_STYLE_VALUES.includes(blockStyle)) {
      listStyles.push(blockStyle);
    } else if (HEADER_BLOCK_STYLE_VALUES.includes(blockStyle)) {
      headerStyles.push(blockStyle);
    } else if (MISC_BLOCK_STYLE_VALUES.includes(blockStyle)) {
      miscStyles.push(blockStyle);
    }
  });
  return {
    INLINE_STYLES: {
      includedStyles: includedStyles
    },
    BLOCK_STYLES: {
      listStyles: listStyles,
      headerStyles: headerStyles,
      miscStyles: miscStyles
    }
  };
}

function configureComposer(_ref) {
  var _ref$betas = _ref.betas,
      betas = _ref$betas === void 0 ? [] : _ref$betas,
      _ref$composerFeatures = _ref.composerFeatures,
      composerFeatures = _ref$composerFeatures === void 0 ? _constants.DEFAULT_COMPOSER_FEATURES : _ref$composerFeatures,
      fileManagerUploadedFileAccess = _ref.fileManagerUploadedFileAccess,
      _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? true : _ref$fullScreen,
      _ref$richTextStyles = _ref.richTextStyles,
      richTextStyles = _ref$richTextStyles === void 0 ? _constants.DEFAULT_RICH_TEXT_STYLES : _ref$richTextStyles,
      usageTracker = _ref.usageTracker;
  var store = (0, _configureStore.default)({
    composerSettings: new _ComposerSettings.default({
      betas: betas,
      features: parseComposerFeaturesIntoKeyMirror(composerFeatures),
      fileManagerUploadedFileAccess: fileManagerUploadedFileAccess,
      fullScreen: fullScreen,
      richTextStyles: parseRichTextStyles(richTextStyles)
    })
  }, {
    usageTracker: usageTracker
  });

  var Composer = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Composer, _Component);

    function Composer() {
      (0, _classCallCheck2.default)(this, Composer);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Composer).apply(this, arguments));
    }

    (0, _createClass2.default)(Composer, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        var _this$props = this.props,
            auth = _this$props.auth,
            compositionId = _this$props.compositionId,
            readOnly = _this$props.readOnly;

        if (auth) {
          store.dispatch((0, _auth.setAuth)(auth));
        }

        store.dispatch((0, _composer.setCompositionId)(compositionId));
        store.dispatch((0, _composer.setCompositionForcedReadOnly)(readOnly));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            backLink = _this$props2.backLink,
            children = _this$props2.children;
        var classes = (0, _classnames.default)({
          'composer-fullscreen-container': fullScreen
        });
        return _react.default.createElement(_reactRedux.Provider, {
          store: store
        }, _react.default.createElement("div", {
          className: classes
        }, _react.default.createElement(_ComposerModalsContainer.default, null), _react.default.createElement(_ComposerContainer.default, {
          backLink: backLink
        }, children)));
      }
    }]);
    return Composer;
  }(_react.Component);

  Composer.defaultProps = {
    readOnly: false
  };
  Composer.propTypes = {
    auth: _propTypes.default.object.isRequired,
    backLink: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    compositionId: _propTypes.default.number,
    children: _propTypes.default.node.isRequired,
    readOnly: _propTypes.default.bool
  };
  Composer.dispatch = store.dispatch;
  return Composer;
}

module.exports = exports.default;